import { MOBILE_SCREEN_MAX_WIDTH } from '../../../constants/screen'

import {
  EMAIL_REPLY_FORM_MOBILE_ACTIONS_MAX_WIDTH,
  EMAIL_REPLY_FORM_MOBILE_ACTIONS_MIN_WIDTH,
} from './EmailReplyFormActions.constants'

export function isEmailReplyFormMobileActions({ screenWidth }) {
  return (
    screenWidth < EMAIL_REPLY_FORM_MOBILE_ACTIONS_MIN_WIDTH ||
    (screenWidth > MOBILE_SCREEN_MAX_WIDTH &&
      screenWidth < EMAIL_REPLY_FORM_MOBILE_ACTIONS_MAX_WIDTH)
  )
}
